import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

import { updateQuizConfig as updateQuizConfigApi } from "../../../../services/apiUsers";

export function useUpdateQuizConfig() {
  const queryClient = useQueryClient();

  const {
    mutate: updateQuizConfig,
    isPending: isUpdating,
    error,
  } = useMutation({
    mutationFn: updateQuizConfigApi,
    onSuccess: () => {
      toast.success("تم تعديل عدد مرات امكانيه الطالب من حضور الاختبار بنجاح");

      queryClient.invalidateQueries({
        queryKey: ["lectureContent"],
      });
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { updateQuizConfig, isUpdating, error };
}
